import React from 'react';
import * as H1 from '../Helper/H1';
import Send from '../Helper/Send';
import { NavLink } from 'react-router-dom';
import { Badge,Message } from 'rsuite';
import moment from 'moment-jalaali'
import 'moment/locale/fa' 
moment.locale('fa')




export default class Dashboard extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            orders: null,
            sub_order: null,
        };
    }


    // ---------------- componentDidMount--------------------------
    componentDidMount() {

        Send('page/orders', "", true).then((res) => {
            this.setState({ 
                orders: res.data.orders,
                sub_order: res.data.sub_order
             });
        }).catch((err) => { });

    }



    render() {

        H1.page_name("سفارشات من");



        return (


            <div className="h-100 mt-4">





                {this.state.orders &&

                    <>


                        <div className="c-row">

                            <div className="text-center mb-4 fs-16">
                            سفارشات من
                            </div>


                            {this.state.orders.length == 0 && this.state.orders.sub_order == 0 &&

                            <Message showIcon type="info">
                              شما درحال حاضر دوره خریداری شده و یا نشان شده ای ندارید.
                            </Message>
                            }
                            


                            {H1.URLParm('new') &&
                                <div className="alertbox mb-3">
                                    <span className="icon-Done ico"></span>
                                    <div className='msg'>
                                        {H1.URLParm('type') === 'diet' ?
                                        'درخواست رژیم غذایی شما با موفقیت ثبت شد. رژیم غذایی شما پس از بررسی کارشناس در همین بخش  قرار خواهد گرفت.'
                                        :H1.URLParm('type') === 'training' && 'درخواست برنامه تمرینی شما با موفقیت ثبت شد. برنامه تمرینی شما پس از بررسی کارشناس در همین بخش  قرار خواهد گرفت.'
                                        }
                                    </div>
                                </div>
                            }


                            {this.state.orders.map((item, index) => [

                                <NavLink exact="true" to={`${item.type =='diet' || item.type =='training' ? '/my' : '' }/${item.type}/${item.type =='diet' || item.type =='training' ? item.id : item.item_id }` } key={'l' + index}>

                                    
                                    <div className='cours_item bg-white br-16 mb-3 position-relative'>


                                    <span className="icon-Basket-Add-Done ico cc-2 type_n fs-18 position-absolute top-50 end-0 translate-middle-y mx-3"></span>
          
                                        <div className="info p-2 px-3">

                                            <div className="py-1"> {item.title}  </div>

                                            <div className="cc-2 mt-1 fs-14"> {moment(item.created_at).fromNow()}</div>
                                        </div>
                                    </div>
                                </NavLink>
                            ])}


                            {this.state.sub_order.map((item, index) => [

                            <NavLink exact="true" to={`/course/${item.id}` } key={'l' + index}>

                                
                                <div className='cours_item bg-white br-16 mb-3 position-relative'>


                                <span className="icon-Basket-Add-Done ico cc-2 type_n fs-18 position-absolute top-50 end-0 translate-middle-y mx-3"></span>

                                    <div className="info p-2 px-3">
       
                                        <div className="py-1"> {item.name}
                                                {item.is_live == 1 && <Badge className='px-2 ms-1' content="لایو" />}
                                        </div>

                                        <div className="cc-2 mt-1 fs-14">اشتراک ویژه</div>
                                    </div>
                                </div>
                            </NavLink>
                            ])}




                        </div>
                    </>
                }

            </div>


        )
    }
}

